// Axios
import Axios from "./axios";

export const deleteWorkshop = (workshopId) => {
  return new Promise((resolve, reject) => {
    const data = Axios.delete(`/academyworkshop/delete/${workshopId}`, {
      headers: {
        "access-token": localStorage.getItem("access_token"),
      },
    });
    resolve(data);
  });
};
